module.exports = __webpack_public_path__ + "static/faceit-logo-black@3x-2aadb1d063e047655357c9f8aa322da0.png";